(function($){
    'use strict';

    var host = location.protocol + '//' + location.host;
    var win = $(window);
    var doc = $(document);

    var Map = {

        filters: {
            region: null,
        },

        paging: 2,
        pagable: true,

        initialized: false,

        initialize: function() {
            if ( this.initialized ) {
              return;
            }
            this.initialized = true;
            this.build();
            this.events();
        },

        build: function(){
            this.map.build();
        },

        events: function(){
            this.map.events();
        },
        map: {
          florida_originated: [
            'florida',
            'southeast',
            'midwest',
            'northeast',
            'eastern-canada'
          ],
          disclaimerToggle: function(region) {
            var $fl_disclaimer = $('#fl-disclaimer');
            if (this.florida_originated.includes(region)) {
              $fl_disclaimer.show();
            } else {
              $fl_disclaimer.hide();
            }
          },
          build: function(){
              $('[id^=tileOption]').hide();
              $('#browseByTile .thumbnail').hide();
          },
          events: function () {
              var self = this;
              doc.on('click', '#mapRegions .region', function(){
                  var region = $(this).attr('id');

                  $('#region').val(region);
                  $('.region').val(region);
                  Map.filters.region = region;
                  Map.map.loadFilters();
                  Map.map.scrollToForm();
                  $('#searchForm').css({ "display":"block" });
                  $('.loader').slideDown(300);
                  self.disclaimerToggle(region);

                  console.log(region);

                  var oldImg = '';
                  var wcnImg = '';



                      $('.wcn-filter').each(function(){

                          wcnImg = $(this).attr('data-src');
                          oldImg = $(this).attr('src');
                          if(region == 'western-canada'){


                                  $(this).attr('src', wcnImg);

                          } else {

                                  $(this).attr('src', oldImg);


                          }

                      });


                  $('.showTileShape option[value="' + region + '"]').prop('selected', true);


              });

            doc.on('change', '.showTileShape', function () {
                  var region = $(this).val();
                  $('.region').val(region);
                  Map.filters.region = region;
                  Map.map.loadFilters();
                  Map.map.scrollToForm();
                  self.disclaimerToggle(region);
              });
              doc.on('change', '#tileShapeSelection', function(){
                  if($('#tileShapeSelection').val()) {
                   $(this).parents('.required').removeClass('has-error');
                  }
              });
              $('#initialFilters').on('submit', function(event){
                  if($('.showTileShape').val()) {
                   return;
                  }
                  $('.showTileShape').parents('.required').addClass('has-error');
                  event.preventDefault();
              });
          },
          scrollToForm: function(){

            var headerHeight = $('.primary-nav').outerHeight();

            $('html,body').animate({
              scrollTop: $('#tile-results').offset().top - headerHeight
            }, 500);
          },
          loadFilters: function(){

              console.log('Loading Filters');
              $('.browse-results').slideDown(300);
              $('#browseByTile .thumbnail').hide();
              $.ajax({
                  type: "GET",
                  cache: false,
                  data: 'region='+Map.filters.region,
                  dataType: 'json',
                  url: host + '/wp-content/themes/eagl/sidebarhandler.php',
                  success: function(data) {
                      console.log(data.profiles);
                      var availableProfiles = data.profiles;
                      var availableWeights = data.weights;
                      var availableColors = data.colors;
                      Map.map.bindToForm(availableProfiles, availableWeights, availableColors);
                      Map.map.showProfileThumbnails(availableProfiles);
                      $('.loader').slideUp(300);
                      $('.zipSearch').addClass('ready');

                  },
                  error: function(jqXHR, textStatus, errorThrown) {
                      alert(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
                  }
              });

          },

          bindToForm: function(availableProfiles, availableWeights, availableColors){

            $('#tileShapeSelection option, #weightSelection option, #colorSelection option')
              .not(':first-child')
              .each(function(){
                  $(this).remove();
              });

            if(availableProfiles.length > 0){
              for(var i = 0; i < availableProfiles.length; i++){
                var profile = availableProfiles[i];
                var profileText = Map.formatDashedString(profile);

                $('#tileShapeSelection').append('<option value="'+profile+'">'+profileText+'</option>');
              }
            }

            if(availableWeights.length > 0){
              for(var j = 0; j < availableWeights.length; j++){
                var weight = availableWeights[j];
                var weightText = Map.formatDashedString(weight);

                $('#weightSelection').append('<option value="'+weight+'">'+weightText+'</option>');
              }
            }

            if(availableColors.length > 0){
              for(var k = 0; k < availableColors.length; k++){
                var color = availableColors[k];
                var colorText = Map.formatDashedString(color);
                console.log(color);
                $('#colorSelection').append('<option value="'+color+'">'+colorText+'</option>');
              }
            }
          },

          showProfileThumbnails: function(availableProfiles){
            //Show Available Profiles
            if(availableProfiles.length > 0){
              for(var i = 0; i < availableProfiles.length; i++){
                var profile = availableProfiles[i];
                $('#tileOption-'+profile).css({'display':'inline-block'});

                var imgHeight = parseInt($('#browse-profile-grid #tileOption-'+profile+' img').height()) + 28;
                $('#tileOption-'+profile).css({'height':imgHeight+'px'});

              }
            }

            $('#browse-profile-grid a').each(function(){
              var profile = $(this).parent().attr('id').replace('tileOption-', '');
              var region = Map.filters.region;
              var link = host+'/products/browse-tile/tile-results/?region='+region+'&profile='+profile;
              $(this).attr('href', link);
            });
        }
      },

      formatDashedString: function(dashedString) {
        if(dashedString !== null){
          var formattedString = dashedString.replace(/\-/g,' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
          return formattedString;
        }
      }
    };
    Map.initialize();
})(jQuery);
